export default "__VITE_ASSET__CfenlKIX__"